import url_acc from '@/urls/accounts'
import { sendPostRequest } from '@/helper/requests'
import { useCookies } from 'vue3-cookies'

const { cookies } = useCookies()

function get_domain () {
  /**
   * Получает домен для установки cookies
   * @returns {string|null} домен или null
   */
  if (process.env.VUE_APP_COOKIE_DOMAIN !== undefined) {
    return process.env.VUE_APP_COOKIE_DOMAIN
  } else {
    return null
  }
}

function set_cookie_store (token, username, uid) {
  /**
   * Устанавливает cookie с данными пользователя
   * @param {string} token - токен аутентификации
   * @param {string} username - имя пользователя
   * @param {string} uid - уникальный идентификатор пользователя
   */
  cookies.remove('userMuctr', null, get_domain()) // удалим старый
  cookies.set(
    'userMuctr',
    {
      userToken: token,
      userName: username,
      userUid: uid
    },
    '3y',
    null,
    get_domain(),
    null
  )
}

const state = {}

const getters = {}

const mutations = {}

const actions = {
  changeAccount: ({ commit }, { data, finalizer, catcher }) => {
    /**
     * Выполняет смену аккаунта пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - данные для смены аккаунта
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.ACCOUNT.CHANGE_ACCOUNT()
    sendPostRequest(
      url, data, (data, url) => {
        if (data.token) {
          set_cookie_store(data.token, data.username, data.uid)
          window.location.reload()
        }
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
}
export default {
  state,
  mutations,
  getters,
  actions
}
